/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// react-router-dom components

// @mui material components
import Card from "@mui/material/Card";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import { styled } from "@mui/system";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// sweetalert2 components
import Swal from "sweetalert2";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
import DataTable from "Tables/DataTable";

// Soft UI Dashboard PRO React components
import SoftBadge from "components/SoftBadge";

// ProductsList page components
import ActionCell from "views/stucked-fixtures-list/components/ActionCell";

import { getData, postData } from "Utils/server";
import { getAuthorizationHeader, getUserData } from "Utils/helpers";

import { useSoftUIController } from "context";

// Badges
const disabledTemplate = (
  <SoftBadge variant="contained" color="error" size="xs" badgeContent="Disabled" container />
);
const enabledTemplate = (
  <SoftBadge variant="contained" color="success" size="xs" badgeContent="Enabled" container />
);

/**
 *
 */
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    //backgroundColor: "#f5f5f9",
    backgroundColor: "#000",
    color: "rgba(f, f, f, 1)", //"rgba(0, 0, 0, 0.87)",
    placement: "left",
    maxWidth: 500,
    minWidth: "minContent",
    height: "minContent",
    textAlign: "left",
    fontSize: "0.65erm",
    border: "1px solid #dadde9",
    boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
    padding: "15px",
  },
}));

let providersOptions = null;
let currentData = [];

/**
 *
 * @returns
 */
function StuckedFixturesList() {
  const abortController = new AbortController();

  const userData = getUserData();

  const [controller, dispatch] = useSoftUIController();
  const { platform, providers } = controller;

  const [loading, setLoading] = useState(true);
  const [updateEnabled, setUpdateEnabled] = useState(false);
  const [hiddenColumns, setHiddenColumns] = useState(["sport_id", "selected"]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [apiResponse, setApiresponse] = useState("success");
  const [apiResponseMsg, setApiResponseMsg] = useState("success");

  const [dataTableData, setDataTableData] = useState({
    columns: [
      { Header: "id", accessor: "id", width: "100px" },
      { Header: "Provider", accessor: "provider", width: "100px" },
      {
        Header: "Region",
        accessor: "region",
        width: "120px",
      },
      {
        Header: "Competition",
        accessor: "competition",
        width: "120px",
      },
      {
        Header: "Home",
        accessor: "home",
        width: "120px",
      },
      {
        Header: "Away",
        accessor: "away",
        width: "120px",
      },
      {
        Header: "since (min)",
        accessor: "since",
        width: "120px",
      },
      { Header: "action", accessor: "action", width: "120px" },
    ],

    rows: [],
  });

  const handleBlockFixture = async (e, fixture = null) => {
    e.preventDefault();

    let fixtures = [];

    if (fixture) {
      fixture.status = true;
      const signalFix = { provider_id: fixture.providerId, fixture_id: fixture.id, status: true };
      fixtures.push(signalFix);
    } else {
      if (!selectedRows) return;
      for (let index = 0; index < selectedRows.length; index++) {
        const fixture = selectedRows[index];
        const signalFix = { provider_id: fixture.providerId, fixture_id: fixture.id, status: true };
        fixtures.push(signalFix);
      }
    }

    Swal.fire({
      title: `You are going to BAN ${
        fixtures.length > 1 ? "these Fixtures" : "this Fixture"
      } from Feed. \nAre you Sure?`,
      html: `<SoftBox pr={1} style={{ marginRight: "auto" }}>
                        ${fixtures.map(
                          (f) =>
                            `<SoftTypography key=${f.fixture_id} variant="caption">
                            ${f.fixture_id}
                          </SoftTypography>`
                        )}
                        
                      </SoftBox>`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: `Yes, BAN ${fixtures.length == 1 ? "it" : "them"}!`,
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "success",
      // denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let setOddNoteEndPoint = `/api/v2/panel/filters/fixtures/blocked`;

        let response = await postData(setOddNoteEndPoint, fixtures, {
          Authorization: getAuthorizationHeader(),
        });

        if (response != null) {
          setApiresponse("success");
          setApiResponseMsg("Fixture Blocked succesfully!");
          initData();
        } else {
          setApiresponse("error");
          setApiResponseMsg(
            "Something went wrong! Fixture doesn't Blocked. Please try again later. "
          );
        }
      }
    });
  };

  /**
   *
   */
  const handleTableDataChanges = async ({ key, value, extra }) => {
    if (key == "refresh") {
      initData();
    }

    if (key == "selectOne") {
      setUpdateEnabled(false);
      setHiddenColumns([]);
      setDataTableData({ columns: [], rows: [] });

      let dataRow = currentData.rows.find((item) => item.id == value);
      dataRow.selected = extra;
      let rows = selectedRows;
      let rowExist = rows.findIndex((item) => item.id == value);
      if (rowExist > -1) {
        if (!extra) {
          rows.splice(rowExist, 1);
          setSelectedRows(rows);
        }
      } else {
        if (extra) {
          rows.push(dataRow);
          setSelectedRows(rows);
        }
      }
      if (rows.filter((r) => r.selected).length > 0) setUpdateEnabled(true);

      setHiddenColumns(["sport_id", "selected"]);
      setDataTableData(currentData);
    }

    if (key == "selectAll") {
      setUpdateEnabled(false);
      setHiddenColumns([]);
      setDataTableData({ columns: [], rows: [] });
      let dataRows = currentData.rows;
      if (extra == "all") {
        dataRows = value;
        for (let index = 0; index < dataRows.length; index++) {
          const dataRow = dataRows[index];
          dataRow.selected = true;
        }
        setSelectedRows(dataRows);
      } else if (extra == "none") {
        dataRows = value;
        for (let index = 0; index < dataRows.length; index++) {
          const dataRow = dataRows[index];
          dataRow.selected = false;
        }
        setSelectedRows([]);
      }
      if (dataRows.filter((r) => r.selected).length > 0) setUpdateEnabled(true);

      setHiddenColumns(["sport_id", "selected"]);
      setDataTableData(currentData);
    }
  };

  const createRow = (el) => {
    const slittedParts = el.split(":");
    const row = {};
    row.id = slittedParts[1];
    row.providerId = slittedParts[0];
    row.provider = providers.find((p) => p.value == slittedParts[0])?.label ?? slittedParts[0];
    row.region = slittedParts[2];
    row.competition = slittedParts[3];
    row.home = slittedParts[4].split(" vs ")[0];
    row.away = slittedParts[4].split(" vs ")[1];
    row.since = slittedParts[5];
    row.action = <ActionCell handleBlockAction={(e) => handleBlockFixture(e, row)} />;
    row.selected = false;
    return row;
    // selections.push({
    //   value: el.template_id + "--" + el.filter + "--" + el.provider_id,
    //   label: el.name,
    // });
    // });
    // setFiltersSelection(selections);
  };

  /**
   *
   */
  async function initData() {
    setUpdateEnabled(false);
    if (!platform || platform == "") return;
    if (!providersOptions || providersOptions == "") return;
    setLoading(true);
    let selectedPlatformId = platform.value;
    let getTemplatesEndpoint = `/api/v2/signals/getstuckedfixtures`;
    let response = await getData(
      getTemplatesEndpoint,
      { Authorization: getAuthorizationHeader() },
      null,
      abortController ? { signal: abortController.signal } : null
    );
    let rows = [];
    if (response != null) {
            rows = response.data.map((el) => {
        return createRow(el);
      });
    } else {
    }

    let data = { ...dataTableData };
    data.rows = response && response.data ? rows : data.rows;

    data.rows.sort((a, b) => b.id - a.id);

    //console.log("Init Data");
    setDataTableData(data);

    currentData = { ...data };
    setLoading(false);
  }

  useEffect(() => {
    if (providers) {
      providersOptions = providers;
      initData();
    }
  }, [platform.label, providers]);

  useEffect(() => {
    return () => {
      if (abortController) {
        // console.log("abortController");
        abortController.abort();
      }
    };
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <SoftBox my={3}>
        <Card>
          <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" p={3}>
            <SoftBox lineHeight={1}>
              <SoftTypography variant="h5" fontWeight="medium">
                Stucked Fixtures
              </SoftTypography>
              <SoftTypography variant="button" fontWeight="regular" color="text">
                Here you can find all the Stucked Fixtures
              </SoftTypography>
            </SoftBox>
            <SoftBox lineHeight={1}>
              <Button
                disabled={updateEnabled ? false : true}
                onClick={(e) => handleBlockFixture(e)}
              >
                block
              </Button>
            </SoftBox>
          </SoftBox>
          <DataTable
            table={dataTableData}
            entriesPerPage={{
              defaultValue: 10,
              entries: [5, 10, 15, 20, 25],
            }}
            hiddenColumns={[]}
            refreshEnabled={true}
            openBackDrop={loading}
            checkboxSelection={true}
            informParent={handleTableDataChanges}
            canSearch
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default StuckedFixturesList;
